<template>
  <div class="createCurriculumSystem">
    <el-page-header
      content="课程预览"
      @back="
        $router.push({
          path: '/school-home-page/owncourse',
        })
      "
    >
    </el-page-header>

    <div class="table-style">
      <el-table
        size="mini"
        :data="ruleForm.curriculum_classes_list"
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column
          width="80"
          align="center"
          prop="sort_num"
          label="排序号"
        ></el-table-column>

        <el-table-column prop="id" label="缩略图">
          <template slot-scope="scope">
            <el-image
              style="width: 60px; height: 45px"
              :src="scope.row.img_url"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column
          width="250"
          prop="title"
          label="讲次名称"
        ></el-table-column>
        <el-table-column
          width="250"
          prop="desc"
          label="讲次简介"
        ></el-table-column>

        <el-table-column label="文件大小" align="center">
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.total_storage >= 1024 &&
                scope.row.total_storage < 1048576
              "
            >
              {{ parseFloat(scope.row.total_storage / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.total_storage < 1024"
              >{{ scope.row.total_storage }} KB
            </span>
            <span v-else>
              {{ parseFloat(scope.row.total_storage / 1024 / 1024).toFixed(2) }}
              GB
            </span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="PreviewCourse(scope.row)"
              >预览</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  getCurriculum,
  updateCurriculumInfo,
  deleteSchoolSelfCurriculumMaterial,
  addOrUpdateSchoolSelfCurriculum,
  addOrUpdateSchoolSelfCurriculumMaterial,
  getSchoolSelfCurriculum
} from "@/api/educational";

import uploadFile from "@/config/uploadFile";

export default {
  name: "preview-owncourse",
  data() {
    return {
      uploadFileTime: false,
      dialogVisible: false,
      subjectList: [],
      ruleForm: {
        subject_id: "",
        teaching_type: "",
        number_of_courses: 1,
        sort_num: 1,
        curriculum_name: "",
        curriculum_url: [],
        curriculum_classes_list: [],
        curriculum_type: "", //课程类型
        curriculum_desc: "", //课程简介
        imgList: [],
        img_url: "", //课程体系缩略图
      },
      curriculum_name: "",
      //课程参数
      curriculumRow: {
        created_time: null,
        subject_id: null,
        curriculum_id: null,
        title: null,
        sort_num: null,
        ppt_url: "",
        desc: null,
        other_meterial_url: "",
        train_video_url: "", //师训视频
        exampal_video_url: "", //课堂实录
        lession_plan_url: "", //备课指南
        exampal_work_url: "", //课堂成果
        teach_template_url: "", //授课模板
        home_template_url: "", //作业模板
        stu_note_url: "", //学生讲义
        imgList1: [], //讲次缩略图
        pptList: [], //ppt 课件
        planList: [], //备课指南
        train_videoList: [], //师训视频
        example_videoList: [], //课堂实录视频
        stu_noteList: [], //学生讲义参数
        exampal_workList: [], //课堂成果sb3 文件
        teach_templateList: [], //授课模板 sb3
        home_templateList: [], //课后作业 sb3
        learn_videoList: [], //录播视频参数
        id: null,
      },

      edit_state: "add_curriculum",

      curriculumRowIndex: 0,
      rules: {
        curriculum_name: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        teaching_type: [
          { required: true, message: "请选择类别", trigger: "change" },
        ],
        number_of_courses: [
          { required: true, message: "请输入课程次数", trigger: "change" },
        ],
        sort_num: [
          { required: true, message: "请输入排序号", trigger: "change" },
        ],
        subject_id: [
          { required: true, message: "请选择科目", trigger: "change" },
        ],
        desc: [
          { required: true, message: "请填写讲次简介", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    //this.getUserSubjectList();
    //this.getCurriculum({}, true);
    this.getSchoolSelfCurriculum();
  },
  methods: {
    PreviewCourse(row) {
      this.$router.push({
        name: "look-owncourse",
        query: {
          curriculumMaterial_id: row.id,
          backname: "owncourse",
        },
        params:{
          curriculumMaterial:row
        }
      });
    },

    //新建校区课程体系
    addOrUpdateSchoolSelfCurriculum() {
      console.log("提交课程体系参数");
      console.log(this.ruleForm);

      addOrUpdateSchoolSelfCurriculum({
        curriculum_id: this.$route.query.id,
        title: this.ruleForm.curriculum_name, //体系名称
        subject_id: this.ruleForm.subject_id, //科目id
        teaching_type: this.ruleForm.teaching_type, //授课类型
        sort_num: this.ruleForm.sort_num, //排序号
        curriculum_data_url: "", //课程资料 [{ name: '课程资料1', 'url': 'http://www.baidu.com', sort_num: 1 }]
        curriculum_type: this.ruleForm.curriculum_type, // 课程类型
        curriculum_desc: this.ruleForm.curriculum_desc, //课程描述
        img_url: this.ruleForm.imgList[0].url, //课程封面缩略图
      }).then((res) => {
        console.log("新建课程体系");
        console.log(res);
        if (res.is_update) {
          this.$message.success("修改成功");
          this.$router.push({ name: "owncourse" });
        }
      });
    },

    // 编辑课程体系
    updateCurriculumInfo(status) {
      if (!this.ruleForm.curriculum_name) {
        this.$message.warning("请填写课程名称");
        return;
      }
      /*
      if (!this.ruleForm.curriculum_url.length) {
        this.$message.warning("请上传课程资料");
        return;
      }*/

      console.log("修改课程体系");
      console.log(this.ruleForm.imgList[0].url);

      updateCurriculumInfo(
        {
          curriculum_id: this.$route.query.id,
          curriculum_name: this.ruleForm.curriculum_name,
          subject_id: this.ruleForm.subject_id,
          teaching_type: this.ruleForm.teaching_type,
          number_of_courses: this.ruleForm.number_of_courses,
          sort_num: this.ruleForm.sort_num,
          curriculum_url: JSON.stringify(this.ruleForm.curriculum_url),
          curriculum_classes_list: JSON.stringify(
            this.ruleForm.curriculum_classes_list
          ),
          curriculum_type: this.ruleForm.curriculum_type, //课程类型ID（1体验课，2常规课，3短期课)
          curriculum_desc: this.ruleForm.curriculum_desc,
          img_url: this.ruleForm.imgList[0].url,
        },
        true
      ).then(() => {
        this.$message.success("修改成功");
        console.log(status);
        if (status === "edit") {
          this.dialogVisible = false;
          this.getCurriculum({}, true);
        } else {
          this.$router.push({ name: "platform-curriculum" });
        }
      });
    },
    // 下载文件
    downLoad(url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$message.warning("文件未上传");
      }
    },

    deleteCurriculum(row, index) {
      console.log("删除课程");
      console.log(row);
      console.log(index);

      this.$confirm("删除本节课程吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteSchoolSelfCurriculumMaterial(
            {
              curriculumMaterial_id: row.id,
            },
            true
          ).then((res) => {
            console.log(res);
            if (res.is_delete) {
              this.$message.success("删除成功!");
              this.dialogVisible = false;
              this.getCurriculum({}, true);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    editCurriculum(row, index) {
      //编辑课程
      console.log("row");
      console.log(row);

      this.edit_state = "edit_curriculum";

      //TODO 初始化数据
      this.curriculumRow.created_time = row.created_time;
      this.curriculumRow.curriculum_id = row.curriculum_id;
      this.curriculumRow.id = row.id;
      this.curriculumRow.desc = row.desc;
      this.curriculumRow.sort_num = row.sort_num;
      this.curriculumRow.subject_id = row.subject_id;
      this.curriculumRow.title = row.title;
      this.curriculumRow.url = row.url;
      this.curriculumRow.ppt_url = row.ppt_url;
      this.curriculumRow.other_meterial_url = row.other_meterial_url;
      this.curriculumRow.train_video_url = row.train_video_url;
      this.curriculumRow.exampal_video_url = row.exampal_video_url;
      this.curriculumRow.lession_plan_url = row.lession_plan_url;
      this.curriculumRow.exampal_work_url = row.exampal_work_url;
      this.curriculumRow.teach_template_url = row.teach_template_url;
      this.curriculumRow.home_template_url = row.home_template_url;
      this.curriculumRow.stu_note_url = row.stu_note_url;
      this.curriculumRowIndex = index;

      //课件参数
      if (row.ppt_url) {
        this.curriculumRow.pptList = [
          {
            url: JSON.parse(row.ppt_url)[0].url,
            name: JSON.parse(row.ppt_url)[0].name,
          },
        ];
      }
      //备课指南

      if (row.lession_plan_url) {
        this.curriculumRow.planList = [
          {
            url: JSON.parse(row.lession_plan_url)[0].url,
            name: JSON.parse(row.lession_plan_url)[0].name,
          },
        ];
      }
      //师训视频
      if (row.train_video_url) {
        this.curriculumRow.train_videoList = [
          {
            url: JSON.parse(row.train_video_url)[0].url,
            name: JSON.parse(row.train_video_url)[0].name,
          },
        ];
      }
      //课堂实录
      if (row.exampal_video_url) {
        this.curriculumRow.example_videoList = [
          {
            url: JSON.parse(row.exampal_video_url)[0].url,
            name: JSON.parse(row.exampal_video_url)[0].name,
          },
        ];
      }

      //学生讲义
      if (row.stu_note_url) {
        this.curriculumRow.stu_noteList = [
          {
            url: JSON.parse(row.stu_note_url)[0].url,
            name: JSON.parse(row.stu_note_url)[0].name,
          },
        ];
      }

      //课堂成果sb3
      this.curriculumRow.exampal_workList = [
        {
          url: row.exampal_work_url,
          name: row.exampal_work_url.split("/")[
            row.exampal_work_url.split("/").length - 1
          ],
        },
      ];

      //授课空模板
      this.curriculumRow.teach_templateList = [
        {
          url: row.teach_template_url,
          name: row.teach_template_url.split("/")[
            row.teach_template_url.split("/").length - 1
          ],
        },
      ];
      //课后作业sb3
      this.curriculumRow.home_templateList = [
        {
          url: row.home_template_url,
          name: row.home_template_url.split("/")[
            row.home_template_url.split("/").length - 1
          ],
        },
      ];

      //录播视频
      if (row.video_url) {
        this.curriculumRow.learn_videoList = [
          {
            url: JSON.parse(row.video_url)[0].url,
            name: JSON.parse(row.video_url)[0].name,
          },
        ];
      }

      this.curriculumRow.imgList1 = [
        {
          url: row.img_url,
          name: row.img_url.split("/")[row.img_url.split("/").length - 1],
        },
      ];

      this.dialogVisible = true;
    },

    addCurriculum() {
      this.dialogVisible = true;
      this.edit_state = "add_curriculum";

      getCurriculum(
        {
          curriculum_id: this.$route.query.id,
        },
        true
      ).then((res) => {
        console.log("课程信息");
        console.log(res);

        this.curriculumRow.subject_id = res.curriculum[0].subject_id;
        this.curriculumRow.curriculum_id = res.curriculum[0].id;

        console.log(this.curriculumRow);
      });
    },

    // 获取课程体系详情
    getCurriculum() {
      getCurriculum(
        {
          curriculum_id: this.$route.query.id,
        },
        true
      ).then((res) => {
        this.ruleForm.curriculum_name = res.curriculum[0].title;
        this.curriculum_name = res.curriculum[0].title;
        this.ruleForm.subject_id = res.curriculum[0].subject_id;
        this.ruleForm.teaching_type = res.curriculum[0].teaching_type;
        this.ruleForm.sort_num = res.curriculum[0].sort_num;
        this.ruleForm.number_of_courses = res.curriculum[0].number_of_courses;
        this.ruleForm.curriculum_url = JSON.parse(
          res.curriculum[0].curriculum_data_url
        );
        this.ruleForm.curriculum_classes_list = res.curriculum_material_list;
        this.ruleForm.curriculum_desc = res.curriculum[0].curriculum_desc;
        this.ruleForm.curriculum_type = res.curriculum[0].curriculum_type;

        this.ruleForm.imgList = [
          {
            url: res.curriculum[0].img_url,
            name: res.curriculum[0].img_url.split("/")[
              res.curriculum[0].img_url.split("/").length - 1
            ],
          },
        ];

        console.log("课程体系-修改教学计划");
        console.log(res);
      });
    },

getSchoolSelfCurriculum()
{
    getSchoolSelfCurriculum({
      curriculum_id:this.$route.query.id
    }).then((res)=>{
      console.log("学校课程体系详情");
      console.log(res);
      this.ruleForm.curriculum_classes_list = res.curriculum_material_list;
    })
},



    // 编辑确定
    addCourse() {
      if (!this.curriculumRow.title) {
        this.$message.warning("请填写课程名称");
        return;
      }

      if (this.curriculumRow.pptList.length == 0) {
        this.$message.warning("请上传课件");
        return;
      }

      if (this.edit_state === "add_curriculum") {
        console.log("增加课程");

        console.log("this.curriculumRow");
        console.log(this.curriculumRow);

        addOrUpdateSchoolSelfCurriculumMaterial(
          {
            subject_id: this.curriculumRow.subject_id,
            curriculum_id: this.curriculumRow.curriculum_id,
            title: this.curriculumRow.title,
            desc: this.curriculumRow.desc,
            sort_num: this.curriculumRow.sort_num,

            ppt_url:
              this.curriculumRow.pptList.length !== 0
                ? JSON.stringify(this.curriculumRow.pptList)
                : null,
            img_url: this.curriculumRow.imgList1[0].url,
            lession_plan_url:
              this.curriculumRow.planList.length !== 0
                ? JSON.stringify(this.curriculumRow.planList)
                : null,
            stu_note_url:
              this.curriculumRow.stu_noteList.length !== 0
                ? JSON.stringify(this.curriculumRow.stu_noteList)
                : null,
            video_url:
              this.curriculumRow.learn_videoList.length !== 0
                ? JSON.stringify(this.curriculumRow.learn_videoList)
                : null,
            train_video_url:
              this.curriculumRow.train_videoList.length !== 0
                ? JSON.stringify(this.curriculumRow.train_videoList)
                : null,
            exampal_video_url:
              this.curriculumRow.example_videoList.length !== 0
                ? JSON.stringify(this.curriculumRow.example_videoList)
                : null,

            exampal_work_url: this.curriculumRow.exampal_workList[0].url,
            teach_template_url: this.curriculumRow.teach_templateList[0].url,
            home_template_url: this.curriculumRow.home_templateList[0].url,
          },
          true
        ).then((res) => {
          console.log("增加课程");
          console.log(res);

          if (res.is_create) {
            this.$message.success("添加成功");

            this.quitaddCourse();

            this.getCurriculum({}, true);
          }
        });
      } else {
        console.log("编辑课程");
        addOrUpdateSchoolSelfCurriculumMaterial(
          {
            curriculumMaterial_id: this.curriculumRow.id,
            subject_id: this.curriculumRow.subject_id,
            curriculum_id: this.curriculumRow.curriculum_id,
            title: this.curriculumRow.title,
            desc: this.curriculumRow.desc,
            sort_num: this.curriculumRow.sort_num,

            ppt_url:
              this.curriculumRow.pptList.length !== 0
                ? JSON.stringify(this.curriculumRow.pptList)
                : null,
            img_url: this.curriculumRow.imgList1[0].url,
            lession_plan_url:
              this.curriculumRow.planList.length !== 0
                ? JSON.stringify(this.curriculumRow.planList)
                : null,
            stu_note_url:
              this.curriculumRow.stu_noteList.length !== 0
                ? JSON.stringify(this.curriculumRow.stu_noteList)
                : null,
            video_url:
              this.curriculumRow.learn_videoList.length !== 0
                ? JSON.stringify(this.curriculumRow.learn_videoList)
                : null,
            train_video_url:
              this.curriculumRow.train_videoList.length !== 0
                ? JSON.stringify(this.curriculumRow.train_videoList)
                : null,
            exampal_video_url:
              this.curriculumRow.example_videoList.length !== 0
                ? JSON.stringify(this.curriculumRow.example_videoList)
                : null,

            exampal_work_url: this.curriculumRow.exampal_workList[0].url,
            teach_template_url: this.curriculumRow.teach_templateList[0].url,
            home_template_url: this.curriculumRow.home_templateList[0].url,
          },
          true
        ).then((res) => {
          if (res.is_update) {
            this.$message.success("修改成功");
            this.dialogVisible = false;

            this.getCurriculum({}, true);
          }
        });
      }
    },

    EditWorkData() {
      let routeData = this.$router.resolve({
        path: "/background/pyeditor",
        query: {},
      });
      window.open(routeData.href, "_blank");
    },

    // 编辑取消
    quitaddCourse() {
      this.curriculumRow.created_time = null;
      this.curriculumRow.curriculum_id = null;
      this.curriculumRow.id = null;
      this.curriculumRow.desc = null;
      this.curriculumRow.sort_num = null;
      this.curriculumRow.subject_id = null;
      this.curriculumRow.title = null;
      this.curriculumRow.desc = null;
      this.curriculumRow.url = null;
      this.curriculumRow.ppt_url = null;

      this.curriculumRow.other_meterial_url = null;

      this.curriculumRow.train_video_url = null;
      this.curriculumRow.exampal_video_url = null;
      this.curriculumRow.lession_plan_url = null;
      this.curriculumRow.exampal_work_url = null;
      this.curriculumRow.teach_template_url = null;
      this.curriculumRow.home_template_url = null;
      this.curriculumRow.stu_note_url = null;

      this.curriculumRowIndex = 0;
      this.curriculumRow.imgList1 = [];

      this.dialogVisible = false;
    },
    uploadFile() {},
    handleRemove(file, fileList, status) {
      if (status === "curriculum_url") {
        this.ruleForm.curriculum_url = fileList;
      } else {
        this.curriculumRow[status] = fileList;
      }
    },
    async handleChangeFile(file, fileList, status, index) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status, index);
      }
    },

    //课程体系缩略图
    async handleChangeFile1(file, fileList) {
      console.log("上传课程体系缩略图");
      var status = "img_url";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    //讲次缩略图
    async handleChangeFile2(file, fileList) {
      console.log("上传讲次缩略图");
      var status = "course_img_url";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    //课件上传
    async handleChangeFile3(file, fileList) {
      console.log("上传课程课件");
      var status = "course_ppt";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },
    //备课指南
    async handleChangeFile4(file, fileList) {
      console.log("备课指南");
      var status = "course_plan_url";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    //师训视频
    async handleChangeFile5(file, fileList) {
      console.log("师训视频");
      var status = "course_train_videourl";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    //课堂实录
    async handleChangeFile6(file, fileList) {
      console.log("课堂实录");
      var status = "course_example_videourl";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    //学生讲义
    async handleChangeFile7(file, fileList) {
      console.log("学生讲义");
      var status = "course_stu_noteurl";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    //课堂成果 sb3
    async handleChangeFile8(file, fileList) {
      console.log("课堂成果");
      var status = "course_exampal_work_url";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    //授课模板 sb3
    async handleChangeFile9(file, fileList) {
      console.log("授课模板");
      var status = "course_teach_templateurl";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    //课后作业 sb3
    async handleChangeFile10(file, fileList) {
      console.log("课后作业");
      var status = "course_home_templateurl";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    //录播视频
    async handleChangeFile11(file, fileList) {
      console.log("录播视频");
      var status = "course_learn_videoeurl";
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status);
      }
    },

    async uploadFileOss(list, status) {
      this.uploadFileTime = true;

      await uploadFile(
        list,
        this.$store.state.user.userInfo.code +
          "/owncouse/" +
          this.$route.query.id
      ).then((res) => {
        if (status === "curriculum_url") {
          console.log("curriculum_url");
          this.ruleForm.curriculum_url = res;
        } else if (status === "img_url") {
          this.ruleForm.imgList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
            },
          ];

          console.log("this.ruleForm.img_url");
          console.log(this.ruleForm.img_url);
        } else if (status === "course_img_url") {
          this.curriculumRow.imgList1 = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("this.curriculumRow.imgList1");
          console.log(this.curriculumRow.imgList1);
        } else if (status === "course_ppt") {
          this.curriculumRow.pptList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("课件参数");
          console.log(res);
          console.log(this.curriculumRow.pptList);
        } else if (status === "course_plan_url") {
          this.curriculumRow.planList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("备课指南参数");
          console.log(res);
          console.log(this.curriculumRow.planList);
        } else if (status === "course_train_videourl") {
          this.curriculumRow.train_videoList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("师训视频参数");
          console.log(res);
          console.log(this.curriculumRow.train_videoList);
        } else if (status === "course_example_videourl") {
          this.curriculumRow.example_videoList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("课堂实录视频参数");
          console.log(res);
          console.log(this.curriculumRow.example_videoList);
        } else if (status === "course_stu_noteurl") {
          this.curriculumRow.stu_noteList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("学生讲义参数");
          console.log(res);
          console.log(this.curriculumRow.stu_noteList);
        } else if (status === "course_exampal_work_url") {
          this.curriculumRow.exampal_workList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("课堂成果");
          console.log(res);
          console.log(this.curriculumRow.exampal_workList);
        } else if (status === "course_teach_templateurl") {
          this.curriculumRow.teach_templateList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("授课模板");
          console.log(res);
          console.log(this.curriculumRow.teach_templateList);
        } else if (status === "course_home_templateurl") {
          this.curriculumRow.home_templateList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("授课模板");
          console.log(res);
          console.log(this.curriculumRow.home_templateList);
        } else if (status === "course_learn_videoeurl") {
          this.curriculumRow.learn_videoList = [
            {
              url: res[0].url,
              name: res[0].url.split("/")[res[0].url.split("/").length - 1],
              length: res[0].length,
            },
          ];

          console.log("录播视频参数");
          console.log(res);
          console.log(this.curriculumRow.learn_videoList);
        } else {
          this.curriculumRow[status] = res;
        }

        this.uploadFileTime = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.createCurriculumSystem {
  background-color: #ffffff;
  padding: 15px;
  margin: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  .form-style {
    margin-left: 15px;
  }
  .formwrapper {
    margin-left: 15px;
  }
  .formbtn {
    padding-left: 15px;
  }
  .addcourse {
    text-align: right;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 0 20px;
  }
  .table-style {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
</style>
